export default function industryAccordion() {
	if ($('.industry-accordion').length) {
		$('.industry-accordion-item').click(function() {
			var itemSlug = $(this).find('.industry-accordion-item__title').data('item'),
					content = $(this).find('.industry-accordion-item__content'),
					image = $('.industry-accordion-images .industry-accordion-image[data-item-image="' + itemSlug +'"]'),
					activeImage = $('.industry-accordion-images .industry-accordion-image.active');

			// if already active, deactivate it
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				// slide up content
				if (content.length) {
					content.slideUp(250);
				}
			// if inactive, activate
			} else {
				$(this).addClass('active');
				// slide down contnet
				if (content.length) {
					content.slideDown(250);
				}
				// swap images
				if (image.length && !image.hasClass('active')) {
					// fade out old image
					if (activeImage.length) {
						activeImage.removeClass('active');
						activeImage.hide();
					}
					// fade in new image
					image.addClass('active');
					image.fadeIn(250);
				}
			}
		})
	}
}